export const TICKET_STATUS = {
  OPEN: "open",
  IN_PROGRESS: "in_progress",
  RESOLVED: "resolved",
} as const;

export const TICKET_PRIORITY = {
  LOW: "low",
  MEDIUM: "medium",
  HIGH: "high",
  CRITICAL: "critical",
} as const;

export const TICKET_USER_TYPE = {
  CLIENT: "client",
  BUSINESS: "business",
  GUEST: "guest",
} as const;

export const TICKET_CATEGORY = {
  ACCOUNT_ACCESS: "Account Access",
  BILLING: "Billing",
  BOOKING_ISSUE: "Booking Issue",
  REFUND_REQUEST: "Refund Request",
  SERVICE_COMPLAINT: "Service Complaint",
  TECHNICAL_ISSUE: "Technical Issue",
  OTHER: "Other",
} as const;

export const TICKET_CATEGORY_OPTIONS = [
  { value: "", label: "Select Category" },
  { value: TICKET_CATEGORY.ACCOUNT_ACCESS, label: "Account Access" },
  { value: TICKET_CATEGORY.BILLING, label: "Billing" },
  { value: TICKET_CATEGORY.BOOKING_ISSUE, label: "Booking Issue" },
  { value: TICKET_CATEGORY.REFUND_REQUEST, label: "Refund Request" },
  { value: TICKET_CATEGORY.SERVICE_COMPLAINT, label: "Service Complaint" },
  { value: TICKET_CATEGORY.TECHNICAL_ISSUE, label: "Technical Issue" },
  { value: TICKET_CATEGORY.OTHER, label: "Other" },
];

export const TICKET_CATEGORY_FORM_OPTIONS = TICKET_CATEGORY_OPTIONS.filter(
  (option) => option.value !== ""
);

export const TICKET_STATUS_OPTIONS = [
  { value: "", label: "All Status" },
  { value: TICKET_STATUS.OPEN, label: "Open" },
  { value: TICKET_STATUS.IN_PROGRESS, label: "In Progress" },
  { value: TICKET_STATUS.RESOLVED, label: "Resolved" },
];

export const TICKET_STATUS_FORM_OPTIONS = [
  { value: TICKET_STATUS.OPEN, label: "Open" },
  { value: TICKET_STATUS.IN_PROGRESS, label: "In Progress" },
  { value: TICKET_STATUS.RESOLVED, label: "Resolved" },
];

export const TICKET_USER_TYPE_OPTIONS = [
  { value: "", label: "All User Types" },
  { value: TICKET_USER_TYPE.CLIENT, label: "Client" },
  { value: TICKET_USER_TYPE.BUSINESS, label: "Business" },
  { value: TICKET_USER_TYPE.GUEST, label: "Guest" },
];

export const TICKET_PRIORITY_OPTIONS = [
  { value: "", label: "All Priorities" },
  { value: TICKET_PRIORITY.LOW, label: "Low" },
  { value: TICKET_PRIORITY.MEDIUM, label: "Medium" },
  { value: TICKET_PRIORITY.HIGH, label: "High" },
  { value: TICKET_PRIORITY.CRITICAL, label: "Critical" },
];

export const TICKET_STATUS_BADGE: Record<string, string> = {
  [TICKET_STATUS.OPEN]: "light-info",
  [TICKET_STATUS.IN_PROGRESS]: "light-warning",
  [TICKET_STATUS.RESOLVED]: "light-success",
};

export const TICKET_STATUS_LABEL: Record<string, string> = {
  [TICKET_STATUS.OPEN]: "Open",
  [TICKET_STATUS.IN_PROGRESS]: "In Progress",
  [TICKET_STATUS.RESOLVED]: "Resolved",
};

export const TICKET_PRIORITY_BADGE: Record<string, string> = {
  [TICKET_PRIORITY.LOW]: "light-secondary",
  [TICKET_PRIORITY.MEDIUM]: "light-info",
  [TICKET_PRIORITY.HIGH]: "light-warning",
  [TICKET_PRIORITY.CRITICAL]: "light-danger",
};

export const isResolvedTicket = (status: string) =>
  normalizeTicketStatus(status) === TICKET_STATUS.RESOLVED;

export const normalizeTicketStatus = (status?: string | null) =>
  status?.toLowerCase() ?? TICKET_STATUS.OPEN;

export const normalizeTicketPriority = (priority?: string | null) =>
  priority?.toLowerCase() ?? "";

export const formatTicketStatus = (status?: string | null) =>
  TICKET_STATUS_LABEL[normalizeTicketStatus(status)] ?? status ?? "";

export const getTicketStatusBadgeColor = (status?: string | null) =>
  TICKET_STATUS_BADGE[normalizeTicketStatus(status)] ?? "light-primary";

export const getTicketPriorityBadgeColor = (priority?: string | null) =>
  TICKET_PRIORITY_BADGE[normalizeTicketPriority(priority)] ?? "light-secondary";

/** @deprecated use TICKET_STATUS_BADGE */
export const ticketStatusObj = TICKET_STATUS_BADGE;
